import React from "react";
import { Box, Card, Flex } from "rebass";

import { ActiveRecord } from "../ActiveRecord";
import { ControlPopover, ControlType } from "../ControlPopover";
import { RecordControl } from "../RecordControl";
import { SpeedControl } from "../SpeedControl";
import { StreamControl } from "../StreamControl";
import { VoiceControl } from "../VoiceControl";

const CONTROL_ELEMENTS = [
  { controlType: ControlType.voice, Content: VoiceControl },
  { controlType: ControlType.display, Content: RecordControl },
  { controlType: ControlType.speed, Content: SpeedControl },
];

export const Player: React.FC = () => (
  <Card
    px="16px"
    py="8px"
    borderTop="2px solid"
    borderTopColor="sp-gray"
    bg="#fff"
    css="position: relative; display: flex; justify-content: space-between; align-items: center;"
  >
    <Box>
      <ActiveRecord />
    </Box>

    <Box css="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <StreamControl />
    </Box>

    <Flex mx="-5px">
      {
        CONTROL_ELEMENTS.map(({ controlType, Content }) => (
          <ControlPopover key={controlType} controlType={controlType}>
            <Content />
          </ControlPopover>
        ))
      }
    </Flex>
  </Card>
);
